<template>
    <div class="btns move-in-from-top" >
        <a :href="'?'+somlink" class="linkscroll" :data-name="somlink" v-on:click="animatescrol">{{somtext}}</a>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "MenuBtn",
        props:['somlink', 'somtext', 'numb'],
        computed: mapState(["navLinks",]),
        mounted() {
            this.anchor_block = {}
            this.all_anchors()
            let idcounter = this.numb+2
            function menushow(el){
                el.classList.add('start')
            }
            setTimeout(menushow, idcounter*250, this.$el);
            window.addEventListener("scroll", this.onScroll)
        },
        unmount() {
            window.removeEventListener("scroll", this.onScroll)
        },
        methods: {
            animatescrol(elm) {
                elm.preventDefault()
                let full_link = elm.target.href
                let anchor_link = full_link.slice(full_link.indexOf('?')+1)
                let prepart = window.innerHeight / 2.1
                window.scrollTo({
                    top: document.getElementById(anchor_link).offsetTop - prepart,
                    behavior: 'smooth'
                })
            },
            title_block_start(idofblock, findclass, diya='add'){
                let fx = idofblock.replace('_content', '')
                let shadow = document.getElementById(fx).getElementsByClassName(findclass)
                if (diya === 'add') {
                    if (shadow[0].className.indexOf('start') < 0) {
                        shadow[0].classList.add('start')
                    }
                }else if(diya ==='remove'){
                    if (shadow[0].className.indexOf('start')>0) {
                        shadow[0].classList.remove('start')
                    }
                }
            },

            onScroll(){
                let windowTop = window.top.scrollY
                this.windowTop = windowTop
                let names_anchor = Object.keys(this.anchor_block)
                names_anchor.map((n)=>{
                    let this_element =this.anchor_block[n]
                    if(this_element['start'] < windowTop && windowTop < this_element['end']){
                        let nalvinks = this.$el.childNodes[0].href.indexOf(n)
                        this.title_block_start(n ,'over_header', 'add')
                        this.title_block_start(n ,'under_header', 'add')
                        if(nalvinks > 0) {
                            this.$el.classList.add('activete')
                        }else{
                            this.$el.classList.remove('activete')
                        }
                    }else if(this.anchor_block['hard_skill_content']['start'] > windowTop && windowTop) {
                        this.$el.classList.remove('activete')
                    }else {
                        this.title_block_start(n ,'over_header', 'remove')
                        this.title_block_start(n ,'under_header', 'remove')
                    }
                })
            },
            get_anchor_position(anch){
                let block_name = anch.replace('_content', '')
                this.anchor_block[anch]= {
                    "start":document.getElementById(block_name).offsetTop - (window.outerHeight*0.65),
                    "end":document.getElementById(block_name).offsetTop + document.getElementById(block_name).offsetHeight - 200
                }
            },
            all_anchors(){
                this.navLinks.map(x=>
                    this.get_anchor_position(x.link)
                )
            },
        }
    }
</script>

<style>
    .move-in-from-top {

        margin-bottom: 100%;
        margin-top: 0;
    }

    .move-in-from-top.start {
        animation: move-in-from-top 1s forwards ease-out;
    }
</style>